import React from 'react';
import withBaseUrl from '@/Utils/const';

export const getFAQSchema = (faqs) => {
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const getBreadcrumbsSchema = (items) => {
  if (!items || !Array.isArray(items) || items.length === 0) return null;

  const baseUrl = withBaseUrl('');
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url.startsWith('http') ? item.url : `${baseUrl}${item.url}`
    }))
  };
};

export const Schema = ({ faqs, breadcrumbs }) => {
  const schemas = [];

  if (faqs) {
    const faqSchema = getFAQSchema(faqs);
    if (faqSchema) {
      schemas.push(
        <script
          key="faq-schema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      );
    }
  }

  if (breadcrumbs) {
    const breadcrumbsSchema = getBreadcrumbsSchema(breadcrumbs);
    if (breadcrumbsSchema) {
      schemas.push(
        <script
          key="breadcrumbs-schema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbsSchema) }}
        />
      );
    }
  }

  return schemas.length > 0 ? <>{schemas}</> : null;
}; 